import { DeviationRequestStatus, DeviationType, DeviationWorkflowType } from 'model/business-enums';
import { DeviationRequest, DeviationRequestWorkflowStrategy, EntityWideDeviationRequest, SingleInstanceDeviationRequest } from 'model/forms/deviation-request';
import { Creatable, UserInfo } from 'model/business-base';
import { EnumInfo } from 'model/platform-types';
import { FileParameter, FileResponse, UploadedFile } from 'model/essential-types';

export abstract class DeviationRequestDetailApi {
  abstract getDeviationRequest(id: number): Promise<DeviationRequestDetail>;
  abstract createSingleInstanceTravelRequest(deviationRequest: SingleInstanceDeviationRequest): Promise<DeviationRequestDetail>;
  abstract createEntityWideTravelRequest(deviationRequest: EntityWideDeviationRequest): Promise<DeviationRequestDetail>;
  abstract updateSingleInstanceTravelRequest(id: number, deviationRequest: SingleInstanceDeviationRequest): Promise<DeviationRequestDetail>;
  abstract updateEntityWideTravelRequest(id: number, deviationRequest: EntityWideDeviationRequest): Promise<DeviationRequestDetail>;
  abstract updateDeviationRequestAttachment(id: number, deviationRequest: DeviationRequest);
  abstract archiveDeviationRequest(id: number): Promise<DeviationRequestDetail>;
  abstract restoreDeviationRequest(id: number): Promise<DeviationRequestDetail>;
  abstract changeStatus(id: number, status: DeviationRequestStatus): Promise<DeviationRequestDetail>;
  abstract assignTo(id: number, assignToId: number | null): Promise<DeviationRequestDetail>;
  abstract uploadAttachment(id: number | null, file: FileParameter): Promise<UploadedFile>;
  abstract downloadAttachment(id: number | null, attachment: UploadedFile): Promise<FileResponse>;
  abstract getWorkflowStrategy(deviationType: DeviationType, workflowType: DeviationWorkflowType);
}

export interface DeviationRequestDetail {
  data: DeviationRequest;
  history: DeviationRequestHistoryRecord[];
  permissions: DeviationRequestPermissions;
  workflowStrategy: DeviationRequestWorkflowStrategy;
}

export interface DeviationRequestHistoryRecord extends Creatable {
  status: EnumInfo<DeviationRequestStatus>;
  assignedTo: UserInfo | null;
  comment: string | null;
}

export interface DeviationRequestPermissions {
  canEdit: boolean;
  canEditAttachment: boolean;
  canAssign: boolean;
  canEditWorkflowFields: boolean;
  canSupportByRegionDirector: boolean;
  canSupport: boolean;
  canReject: boolean;
  canRenew: boolean;
  teamMembersToAssign: UserInfo[];
  canArchive: boolean;
  canRestore: boolean;
}
